export const academicFormationsOptions = [
  {
    label: 'Médico(a)',
    value: 'doctor'
  },
  {
    label: 'Físico Médico',
    value: 'medical_physicist'
  },
  {
    label: 'Fisioterapeuta',
    value: 'physical_therapist'
  },
  {
    label: 'Odontólogo(a)',
    value: 'dentist'
  },
  {
    label: 'Psicólogo(a)',
    value: 'physicological'
  },
  {
    label: 'Fonoaudiólogo(a)',
    value: 'speech_therapist'
  },
  {
    label: 'Nutricionista',
    value: 'nutritionist'
  }
]

export function translateAcademicFormation(value: string): string {
  const option = academicFormationsOptions.find((option) => {
    return option.value === value
  })

  return option ? option.label : ''
}
